<div class="h-full w-full flex-1 overflow-hidden">
    <div class="mb-2 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="w-full">
        <div class="flex flex-1 items-center justify-between gap-4">
        
            <!-- search -->
            <div class="relative">
                <input [(ngModel)]="search" type="text" placeholder="Search.." class="pl-8" />
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                    class="absolute left-2 top-1/2 size-5 -translate-y-1/2 transform">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                </svg>
            </div>
        
            <div class="flex gap-2">
                <!-- Date picker -->
                <div>
                    <div>
                        <input type="text" name="time" id="time" [(ngModel)]="todayDate" [owlDateTime]="date"
                            (ngModelChange)="onDateChange($event)" [owlDateTimeTrigger]="date" [selectMode]="'range'" />
                        <owl-date-time [pickerType]="'calendar'" #date></owl-date-time>
                    </div>
                </div>
                <!-- status wise filter -->
                <div class="relative w-48">
                    <select class="w-full" [(ngModel)]="selectedStatus" (change)="selectStatus()">
                        <option *ngFor="let status of statuses" [value]="status.value">
                            {{status.label}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        </div>
    </div>
    <div class="mt-2 rounded-lg border border-zinc-950/10 bg-white p-2 dark:border-white/10 dark:bg-zinc-950">
        <div class="overflow-x-auto">
            <table class="min-w-full table-auto border-collapse border border-zinc-950/10 dark:border-white/10">
                <thead class="bg-zinc-950/5 dark:bg-white/5">
                    <tr>
                        <th
                            class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            #</th>
                        <th
                            class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            Company</th>
                        <th
                            class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            Status</th>
                        <th
                            class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            Driver</th>
                        <th
                            class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            Member</th>
                        <th
                            class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            Contact No.
                        </th>
                        <th
                            class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            Pickup Time
                        </th>
                        <th
                            class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            Dropoff Time
                        </th>
                        <th
                            class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            Pickup Address</th>
                        <th
                            class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            Dropoff Address</th>
                        <th
                            class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            Miles</th>
                        <th
                            class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            Space Type</th>
                        <th
                            class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            LOS</th>
                        <th
                            class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            Appointment Type</th>
                        <th
                            class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            Created Time</th>

                    </tr>
                </thead>
                <tbody>
                    <tr class="hover:bg-gray-950/5 dark:hover:bg-white/10" *ngFor="let trip of trips | filter: search; let i=index">
                        <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
                            {{i+1}}
                        </td>
                        <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
                            {{trip.company ? trip.company : 'N/A'}}
                        </td>
                        <td
                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            {{ trip.status}}
                        </td>
                        <td
                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            {{ trip.driver ? trip.driver : 'N/A'}}
                        </td>
                        <td
                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            <!-- {{ trip.member }} -->
                            <span *ngIf="preMembers && preMembers[trip.member]">{{preMembers[trip.member].displayName | titlecase}}</span>
                        </td>
                        <td
                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            {{trip.pickup?.phoneNumber ? trip.pickup?.phoneNumber : 'N/A'}}
                        </td>
                        <td
                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            {{trip.pickup?.time | date : 'MM/DD/YYYY HHmm'}}
                        </td>
                        <td
                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            {{trip.destination?.time | date : 'MM/DD/YYYY HHmm'}}
                        </td>
                        <td
                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            {{ trip.pickup?.address?.name ? trip.pickup?.address?.name : 'N/A'}}
                        </td>
                        <td
                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            {{ trip.destination?.address?.name}}
                        </td>
                        <td
                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            {{ trip.miles ? (trip.miles | number:'1.2-2') + ' mi' : '' }}
                        </td>
                        <td
                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            <!-- {{trip.spaceType ? trip.spaceType : 'N/A'}} -->

                            <span
                                *ngIf="preSpaceTypeList && preSpaceTypeList[trip.spaceType]">{{preSpaceTypeList[trip.spaceType].title}}</span>
                        </td>
                        <td
                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            <!-- {{trip.levelOfService ? trip.levelOfService : 'N/A'}} -->
                            <span
                                *ngIf="preLevelOfServiceList && preLevelOfServiceList[trip.levelOfService]">{{preLevelOfServiceList[trip.levelOfService].title
                                | titlecase}}</span>
                        </td>
                        <td
                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            <!-- {{trip.appointmentType ? trip.appointmentType : 'N/A'}} -->
                            <span
                                *ngIf="preAppointmentTypes && preAppointmentTypes[trip.appointmentType]">{{preAppointmentTypes[trip.appointmentType].title
                                | titlecase}}</span>
                        </td>
                        <td
                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                            {{trip.createdAt | date : 'MM/DD/YYYY'}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>